import { render } from "./MobileContactView.vue?vue&type=template&id=581164a4&scoped=true"
import script from "./MobileContactView.vue?vue&type=script&lang=js"
export * from "./MobileContactView.vue?vue&type=script&lang=js"

import "./MobileContactView.vue?vue&type=style&index=0&id=581164a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-581164a4"]])

export default __exports__